<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf">
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="level" label="资质名称" name="level">
          <div class="s_flex_ali">
            <p class="s_c333 m-r-15">中国商标权证书</p>
            <div class="s_flex_ali">
              <WarningOutlined v-if='status !== 1' class="fz-16 s_cd41" />
              <CheckOutlined v-else class="fz-16 s_c376" />
              <p>{{status_text}}</p>
            </div>
          </div>
        </a-form-item>
        <a-form-item ref="brand_name" label="品牌名称" name="brand_name" help='1、请填写中国商标授权书所授权名称相一致的品牌名称。2、品牌名称认证后不可修改。'>
          <a-input v-model:value="form.brand_name" placeholder='请输入企业名称' :disabled='status == 1' />
        </a-form-item>
        <a-form-item ref="trademark_no" label="商标注册号/申请号" name="trademark_no">
          <a-input v-model:value="form.trademark_no" placeholder='请输入商标注册号/申请号' />
        </a-form-item>
        <a-form-item ref="trademark_images" label="中国商标权证书" name="trademark_images" help='注：非以本公司名为持有的商标请务必在补充材料选项上传商标授权书；'>
          <p class="s_c999">请上传有效期内且年检章齐全的证件清晰彩色原件扫描件，或者对应的授权、变更证明</p>
          <material :groupType='1' :image="form.trademark_images" :max="1"
            v-on:handlechoose="(data)=>{form.trademark_images=data}" v-on:handledel="form.trademark_images=''" />
        </a-form-item>
        <a-form-item ref="extend_images" label="补充材料" name="extend_images" help='授权书上传必须为彩色图片，最多3张，格式为bmp、png、jpeg、jpg或gif。'>
          <p class="s_c999">商标持有者为公司的请签公司名并加盖公章；若为个人，请务必由商标持有人亲笔签名。</p>
          <a href="javascript:;">点击下载商标授权书模板</a>
            
          <material :groupType='1' :image="form.extend_images" :max="1"
          v-on:handlechoose="(data)=>{form.extend_images=data}" v-on:handledel="form.extend_images=''" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 5 }">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-layout>
</template>
<script>
  import { WarningOutlined, CheckOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject,watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { getTypeList } from "@/api/store";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    brand_name:'',
    trademark_no:'',
    trademark_images:'',
    extend_images:''
  }
  export default {
    name:'licence',
    components: {WarningOutlined, CheckOutlined },
    props: {
      formData: {
        type: Object
      },
    },
    setup(props,{emit}) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        status:0,
        status_text:'未认证',
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
        rules: {
          brand_name: [
            { required: true, message: '请输入品牌名称'}
          ],
          trademark_no: [
            { required: true, message: '请输入商标注册号/申请号'}
          ],
          trademark_images: [
            { required: true, message: '请上传中国商标权证书'}
          ]
        }
      });
      const ruleForm = ref()
      const _lodash = inject("_lodash");
      const onSubmit = () => {
        ruleForm.value.validate().then(() => {
          emit('onsubmit',form.value)
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
      });
      
      watchEffect(() => {
        var formData = props.formData || {};
        if (!_lodash.isEmpty(formData.detail)) {
          form.value = formData.detail;
          state.status = formData.status
          state.status_text = formData.status_text
        } else {
          form.value = defForm;
          state.status = formData.status
          state.status_text = formData.status_text
        }
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit
      }
    }
  }
</script>
